module.exports = __webpack_public_path__ + "static/FlowerTing-7ea984b2ed034b3aa26aa66d3874d4af.svg";